import type { OperatorRoutePlan } from '@groupe-reca/contracts'
import { canStartRoute, routeActionLabel, routeResidences } from '../routePlan'

/**
 * Routes de l'opérateur dans l'ordre du bureau : action possible dans l'opération ouverte (démarrer, reprendre,
 * nouveau passage), routes occupées ou terminées visibles sans être choisissables. La route suggérée par le serveur
 * est signalée; toucher une route la choisit, rien ne démarre avant le maintien de 2 s.
 */
export function RoutePlanList({
  plan,
  selectedId,
  disabled,
  onSelect,
}: {
  plan: OperatorRoutePlan
  selectedId: string | null
  disabled: boolean
  onSelect: (routeId: string) => void
}) {
  return (
    <fieldset className="op-routes" disabled={disabled}>
      <legend className="field-eyebrow">Vos routes, dans l’ordre du bureau</legend>
      {plan.routes.map((route) => {
        const selectable = canStartRoute(route)
        const selected = route.routeId === selectedId
        return (
          <label
            key={route.routeId}
            className={`op-routes__item${selected ? ' op-routes__item--selected' : ''}${selectable ? '' : ' op-routes__item--off'}`}
          >
            <input
              type="radio"
              name="route"
              value={route.routeId}
              checked={selected}
              disabled={!selectable}
              onChange={() => {
                onSelect(route.routeId)
              }}
            />
            <span className="op-routes__rank">{route.rank}</span>
            <span className="op-swatch" style={{ background: route.color ?? undefined }} aria-hidden="true" />
            <span className="op-routes__body">
              <strong>{route.name ?? 'Route'}</strong>
              <small>
                {routeActionLabel(route)} · {routeResidences(route)}
                {route.available ? '' : ' · indisponible (bureau)'}
              </small>
            </span>
            {route.routeId === plan.nextRouteId ? <span className="op-routes__next">Suggérée</span> : null}
          </label>
        )
      })}
    </fieldset>
  )
}
